export type { EntityNoticeTerminalProps } from './entity-notice-terminal'
export { EntityNoticeTerminal } from './entity-notice-terminal'
